import { Component } from '@angular/core';

import { XpGymHomePage } from "../xp-gym-home/xp-gym-home";
import { XpHomePage } from "../xp-home/xp-home";
import { XpWorkordersPage } from "../xp-workorders/xp-workorders";
import { XpSearchUnitPage } from "../xp-search-unit/xp-search-unit";
import { XpCompanyFilesPage } from "../xp-company-files/xp-company-files";
import { XpNotificationsPage } from "../xp-notifications/xp-notifications";
import { AlertController, NavController } from "ionic-angular";
import { XpReportService } from "../../services/xp-report.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  templateUrl: 'xp-tabs.html'
})
export class XpTabsPage {

  tab1Root = XpGymHomePage;
  tab2Root = XpWorkordersPage;
  tab3Root = XpSearchUnitPage;
  tab4Root = XpCompanyFilesPage;
  tab5Root = XpNotificationsPage;

  workordersTabIndex = 1;
  searchUnitTabIndex = 3;

  menuOpen = false;

  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public reportService: XpReportService
  ) {

  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  getTabs() {
    let navs = this.navCtrl.getActiveChildNavs();
    return navs[0];
  }

  selectTab(index){
    let tabs = this.getTabs();
    return tabs.select(index);
  }

  goToNewWorkorder() {
    this.closeMenu();
    if(this.reportService.isActive()){
      this.alertCtrl.create({
        title: this.translate.instant('Atención'),
        message: this.translate.instant('No podés empezar un entrenamiento nuevo porque ya tenés uno en curso.'),
        cssClass: 'alert-error',
        buttons: ['OK']
      }).present();
      return;
    }
    let tabs = this.getTabs();
    tabs.select(this.workordersTabIndex).then(() => {
      setTimeout(() => {
        let page = tabs.getSelected().getActive().instance;
        if(page instanceof XpWorkordersPage){
          /** @var page XpWorkordersPage **/
          page.chooseNewWorkorderType();
        }
      }, 500);
    });
  }

  goToWorkorders() {
    this.closeMenu();
    this.selectTab(this.workordersTabIndex);
  }

  goToSearchUnit() {
    this.closeMenu();
    this.selectTab(this.searchUnitTabIndex);
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-tabs/xp-tabs.ts